export const settings = {
  // Page header
  title: 'Beállítások',
  subtitle: 'Rendszer beállítások és konfiguráció',
  
  // Tabs
  tabs: {
    organizations: {
      name: 'Szervezetek',
      description: 'Szervezetek kezelése'
    },
    users: {
      name: 'Felhasználók',
      description: 'Felhasználókezelés'
    },
    notifications: {
      name: 'Értesítések',
      description: 'Értesítési beállítások'
    },
    aiSettings: {
      name: 'AI Beállítások',
      description: 'Claude AI integráció'
    },
    emailSettings: {
      name: 'Email / SMTP',
      description: 'Email beállítások'
    },
    emailTemplates: {
      name: 'Email Template-ek',
      description: 'Email sablonok'
    },
    billing: {
      name: 'Számlázás',
      description: 'Számlázási beállítások'
    },
    categories: {
      name: 'Kategóriák',
      description: 'Termékkategóriák'
    }
  },
  
  categories: {
    title: 'Kategóriák',
    subtitle: 'Kategóriák kezelése és szervezése',
    add: 'Új kategória',
    noCategories: 'Nincsenek kategóriák',
    noCategoriesTooltip: 'Kezdjen egy új kategória hozzáadásával',
    fields: {
      name: 'Név',
      productCount: 'Termékek',
      actions: 'Műveletek'
    },
    messages: {
      confirmTitle: 'Kategória törlése',
      deleteQuestion: 'Biztosan törölni szeretné ezt a kategóriát?',
      deleteWarning: 'Ez a művelet nem visszavonható és eltávolítja az összes termék kapcsolatot is.',
      dangerousDeleteWarning: '⚠️ FIGYELEM! Ez a kategória termékeket tartalmaz! A törlés befolyásolhatja ezeket a termékeket is. Ez a művelet nem visszavonható.'
    },
    form: {
      add: 'Kategória hozzáadása',
      edit: 'Kategória szerkesztése',
      addDetails: 'Kategória adatai',
      editDetails: 'Kategória adatainak szerkesztése',
      name: 'Név',
      parent: 'Szülő kategória',
      noParent: 'Nincs szülő (Főkategória)',
      status: 'Állapot',
      active: 'Aktív',
      nameRequired: 'A név megadása kötelező',
      update: 'Kategória frissítése',
      create: 'Kategória létrehozása'
    }
  },
  
  notifications: {
    title: 'Értesítési beállítások',
    subtitle: 'Az értesítési beállítások testreszabása és kezelése',
    
    // Email notifications
    emailNotifications: 'Email értesítések',
    emailDescription: 'Kiválaszthatja, mely események esetén szeretne email értesítést kapni',
    
    // In-app notifications
    inAppNotifications: 'Alkalmazáson belüli értesítések',
    inAppDescription: 'Beállíthatja, mely értesítések jelenjenek meg az alkalmazásban',
    
    // Other settings
    otherSettings: 'Egyéb beállítások',
    otherDescription: 'Hang, asztal értesítések és egyéb beállítások',
    
    // Sound settings
    soundEnabled: 'Hang engedélyezése',
    soundEnabledDesc: 'Hangjelzés új értesítések érkezésekor',
    
    // Desktop notifications
    desktopNotifications: 'Asztali értesítések',
    desktopNotificationsDesc: 'Rendszer értesítések megjelenítése a böngészőben',
    
    // Debug mode
    debugMode: 'Debug mód',
    debugModeDesc: 'Saját magadnak is küldjön értesítéseket (tesztelési célokra)',
    
    // Quiet hours
    quietHours: 'Csendes órák',
    quietHoursDesc: 'Megadhat egy időintervallumot, amikor nem kíván értesítéseket kapni',
    enableQuietHours: 'Csendes órák engedélyezése',
    startTime: 'Kezdés ideje',
    endTime: 'Befejezés ideje',
    
    // Descriptions for notification types
    taskAssignedDesc: 'Értesítést kap, amikor új feladatot jelölnek ki Önnek',
    taskCompletedDesc: 'Értesítést kap, amikor egy feladat befejezésre kerül',
    taskOverdueDesc: 'Értesítést kap, amikor egy feladat lejár',
    projectUpdateDesc: 'Értesítést kap a projektek frissítéseiről',
    deadlineReminderDesc: 'Emlékeztető a közelgő határidőkről',
    systemDesc: 'Rendszer szintű értesítések és bejelentések',
    
    // Messages
    saveSuccess: 'Beállítások sikeresen mentve',
    saveError: 'Hiba történt a beállítások mentése közben',
    loadError: 'Hiba történt a beállítások betöltése közben'
  },
  
  organizations: {
    title: 'Szervezetek',
    subtitle: 'Szervezet adatainak kezelése',
    selectOrg: 'Válasszon szervezetet',
    noOrg: 'Nincs szervezet kiválasztva',
    editOrg: 'Szervezet szerkesztése'
  },
  
  users: {
    title: 'Felhasználók',
    subtitle: 'Felhasználók kezelése és jogosultságok',
    addUser: 'Új felhasználó',
    inviteUser: 'Felhasználó meghívása',
    noUsers: 'Nincsenek felhasználók'
  },
  
  aiSettings: {
    title: 'AI Beállítások',
    subtitle: 'Claude AI integráció konfigurálása',
    apiKey: 'API Kulcs',
    model: 'Modell',
    enabled: 'AI funkciók engedélyezése'
  },
  
  emailSettings: {
    title: 'Email / SMTP Beállítások',
    subtitle: 'Email küldés konfigurálása',
    smtpHost: 'SMTP Szerver',
    smtpPort: 'Port',
    smtpUser: 'Felhasználónév',
    smtpPassword: 'Jelszó',
    fromEmail: 'Feladó email',
    fromName: 'Feladó név',
    testConnection: 'Kapcsolat tesztelése'
  },
  
  emailTemplates: {
    title: 'Email Template-ek',
    subtitle: 'Email sablonok kezelése',
    addTemplate: 'Új sablon',
    editTemplate: 'Sablon szerkesztése',
    noTemplates: 'Nincsenek sablonok'
  },
  
  billing: {
    title: 'Számlázási Beállítások',
    subtitle: 'Számlázó rendszer konfigurálása',
    agentKey: 'Számlázz.hu Agent Key',
    companyInfo: 'Cég adatok',
    bankAccount: 'Bankszámla',
    taxNumber: 'Adószám'
  },
  
  common: {
    save: 'Mentés',
    cancel: 'Mégse',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    add: 'Hozzáadás',
    loading: 'Betöltés...',
    saved: 'Mentve',
    error: 'Hiba történt'
  }
}